import { useMemo } from 'react';
import { useAuth } from './useAuth';
import { TESMCPClient } from '../lib/mcp-client';

export function useMCP() {
  const { accessToken, user } = useAuth();

  const client = useMemo(() => {
    if (!accessToken || !user?.clientId) return null;

    // Use empty string for baseUrl so requests go through local proxy at /api/mcp
    // The proxy forwards to TES_API_URL with proper auth headers
    return new TESMCPClient('', accessToken, user.clientId);
  }, [accessToken, user?.clientId]);

  return client;
}
